module.exports = __webpack_public_path__ + "media/bundles/bundles-center-8eae2e27.svg";